<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/permission-and-role/role/index')">
              mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ساخت نقش جدید</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-text-field color="black" v-model="role.name" label="نام لاتین نقش"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field color="black" v-model="role.label" label="لیبل نقش"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-autocomplete multiple label="دسترسی های متصل به نقش" :items="permissions" item-value="id" item-text="label"
                      color="black" v-model="role.permission_ids">
            </v-autocomplete>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="store()">ذخیره</v-btn>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "RoleCreateView",
  data() {
    return {
      permissions: [],
      role: {
        name: null,
        label: null,
        permission_ids: null,
      }
    }
  },
  mounted() {
    this.getPermissions()
  },
  methods: {
    store() {
      window.axios.post('system/role/create', this.role).then(() => {
        this.openSnackbar("نقش جدید با موفقیت ساخته شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    clear() {
      this.role = {
        name: null,
        label: null,
        permission_ids: null
      }
    },
    getPermissions() {
      window.axios.get('system/permission/index').then((res) => {
        this.permissions = res.data.data
      })
    },
  }
}
</script>

<style>
.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}

.normal-font-btn {
  letter-spacing: normal !important;
}
</style>